module.exports = __webpack_public_path__ + "static/media/Hoboken3.e656a6ab.jpg";